import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "37px",
  height: "37px",
  viewBox: "0 0 37 37",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon_close", -1),
    _createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "icon_close",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("circle", {
          id: "Oval",
          fill: "#115673",
          cx: "18.5",
          cy: "18.5",
          r: "18.5"
        }),
        _createElementVNode("path", {
          d: "M10.2061758,10.9220807 L10.9211497,10.2071068 C11.311674,9.81658249 11.944839,9.81658249 12.3353633,10.2071068 L18.4639279,16.3356713 L18.4639279,16.3356713 L24.6193499,10.1964478 C25.0065589,9.8102577 25.6321774,9.80674353 26.0237004,10.1885594 L26.7750309,10.9212618 C27.170426,11.3068538 27.1783731,11.9399689 26.7927811,12.335364 C26.78986,12.3383594 26.7869202,12.3413364 26.7839617,12.3442948 L20.6462926,18.4819639 L20.6462926,18.4819639 L26.7910287,24.6105297 C27.1820672,25.0005391 27.1829014,25.6337036 26.792892,26.0247421 C26.7925819,26.025053 26.7922715,26.0253638 26.791961,26.0256743 L26.023811,26.7938242 C25.6336505,27.1839848 25.0012039,27.1844014 24.6105297,26.7947552 L18.4639279,20.6643287 L18.4639279,20.6643287 L12.3442948,26.7839617 C11.9537705,27.174486 11.3206055,27.174486 10.9300813,26.7839617 C10.9271228,26.7810032 10.9241829,26.7780262 10.9212618,26.7750309 L10.1894672,26.0246313 C9.80729314,25.632741 9.81122393,25.0064113 10.1982867,24.6193486 L16.3356713,18.4819639 L16.3356713,18.4819639 L10.2052448,12.3353621 C9.81559862,11.9446878 9.81601525,11.3122413 10.2061758,10.9220807 Z",
          id: "Path",
          fill: "#EFE05F"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }